import localbase from "localbase";

export default {
  install(Vue) {
    Vue.prototype.$localbase = {
      async get({ type }) {
        const db = new localbase("db");
        const data = await db.collection(type).get();

        if (data[0]) {
          const now = new Date();
          const expiresAt = new Date(data[0].expiresAt);

          if (expiresAt > now) {
            return { isExpired: false, data: data[0].data };
          }
        }

        return { isExpired: true, data: [] };
      },
      set({ type, data }) {
        const db = new localbase("db");

        function addMinutes(date, minutes) {
          return new Date(date.getTime() + minutes * 60000);
        }

        db.collection(type).set([
          {
            id: type,
            data: data,
            expiresAt: addMinutes(
              new Date(),
              type.includes("carouselImages") ? 5 : 10
            ),
          },
        ]);
      },
    };
  },
};
